
class CapCreateStudentFutureSchedule {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'create_student_future_schedule'
}

function create(config) {
  return new CapCreateStudentFutureSchedule(config)
}

export default {
  key,
  create,
}
